import { AxiosError } from "axios";
import { OfficeServerDetails } from "../../../domain/repositories/ConfigRepository";

export const TRIGGER_CREATE_OFFICE_SERVER = 'CREATE_OFFICE_SERVER.TRIGGER';
export const CREATE_OFFICE_SERVER_PENDING = 'CREATE_OFFICE_SERVER.PENDING';
export const CREATE_OFFICE_SERVER_SUCCESS = 'CREATE_OFFICE_SERVER.SUCCESS';
export const CREATE_OFFICE_SERVER_ERROR = 'CREATE_OFFICE_SERVER.ERROR';

export const RESET_CREATE_OFFICE_SERVER = 'CREATE_OFFICE_SERVER.RESET';

export interface TriggerCreateOfficeServer {
  type: typeof TRIGGER_CREATE_OFFICE_SERVER;
  payload: {
    officeServer: string;
  }
}

export interface CreateOfficeServerPending {
  type: typeof CREATE_OFFICE_SERVER_PENDING;
}

export interface CreateOfficeServerSuccess {
  type: typeof CREATE_OFFICE_SERVER_SUCCESS;
  payload: {
    createdOfficeServerDetails: OfficeServerDetails;
  }
}

export interface CreateOfficeServerError {
  type: typeof CREATE_OFFICE_SERVER_ERROR;
  payload: {
    error: AxiosError;
  }
}

export interface ResetCreateOfficeServer {
  type: typeof RESET_CREATE_OFFICE_SERVER;
}


export type CreateOfficeServerActionType =
  | TriggerCreateOfficeServer
  | CreateOfficeServerPending
  | CreateOfficeServerSuccess
  | CreateOfficeServerError
  | ResetCreateOfficeServer;


export interface CreateOfficeServerState {
  createOfficeServerPending: boolean;
  createOfficeServerError: AxiosError | null;
  createdOfficeServerDetails: OfficeServerDetails | null;
}